import React, { useEffect, useState } from "react";
import {
  Grid,
  Paper,
  TextField,
  Button,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi from "../../api/DnerhsApi";
import FormInput from "../../Controls/Input";
import Alert from "../../components/Alert";
import history from "../../utils/History";
import { useParams, useLocation } from "react-router-dom";
import FormAutocomplete from "../../Controls/Autocomplete";

const useStyles = makeStyles((theme) => ({
  main: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  form: {
    padding: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(1),
  },
  large: {
    width: theme.spacing(16),
    height: theme.spacing(16),
  },
  button: {
    margin: theme.spacing(2),
  },
 
  title: {
    margin: theme.spacing(3),
  },
}));

const Form = () => {
  const classes = useStyles();
  const [sent, setSent] = useState(false);
  const params = useParams();
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isAddMode, setIsAddMode] = useState(false);
  const [usuarioResponseData, setUsuarioResponseData] = useState({});
  const [nombreRoleOptions, setNombreRoleOptions] = useState([]);
  const methods = useForm({});
  const { handleSubmit, reset, setValue } = methods;
  let { state } = useLocation();

  useEffect(() => {
    const load = () => {
      try {
        getServerData();
        if (state?.edit || state?.readOnly) {
          setIsUpdate(state?.edit);
          setIsReadOnly(state?.readOnly);
          setValuesForEdit();
        } else {
          setIsAddMode(true);
        }
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);

  const getServerData = async () => {
    try {
      const response = await DnerhsApi.get("/roles");
      const filtered = response.data.filter(
        (element) => element.id >= 3 && element.id <= 4
      );
      setNombreRoleOptions(
        filtered.map((x) => ({
          descripcion: x.descripcion,
          id: x.id,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  const setValuesForEdit = async () => {
    try {
      const { data: usuario } = await DnerhsApi.get(`/usuarios/${params.id}`);
      setUsuarioResponseData(usuario);
      const formValues = {
        nombreRole: { id: usuario.role.id, descripcion: usuario.role.descripcion },
        username: usuario.username,
        apellidos: usuario.apellidos,
        cedulaIdentidad: usuario.cedulaIdentidad,
        email: usuario.email,
        nombres: usuario.nombres,
        telefono: usuario.telefono,
        cargo: usuario.cargo,
      };

      Object.keys(formValues).forEach((field) => {
        setValue(field, formValues[field]);
      });

      setIsUpdate(true);
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmit = async (data) => {
    let url = "/usuarios/";
    const payload = {
      username: data.username,
      nombres: data.nombres,
      apellidos: data.apellidos,
      cedulaIdentidad: data.cedulaIdentidad,
      telefono: data.telefono,
      cargo: data.cargo,
      email: data.email,
    };

    try {
      if (isUpdate) {
        let payloadUpt = { ...usuarioResponseData, ...payload };
        payloadUpt = { usuario: payloadUpt, password: usuarioResponseData.username };
        await DnerhsApi.put(url, { ...payloadUpt });
        Alert.show({ message: "Datos actualizados exitosamente.", type: "success" });
      } else {
        payload.role = { id: data.nombreRole.id, descripcion: data.nombreRole.descripcion };
        await DnerhsApi.post(url, { usuario: payload, password: data.username });
        Alert.show({ message: "Datos guardados exitosamente.", type: "success" });
      }
      history.goBack();
    } catch (error) {
      console.log(error);
      Alert.show({ message: "Ocurrió un error.", type: "error" });
    }
  };

  return (
    <div className={classes.main}>
      <Grid container>
        <Grid item xs={12}>
          <Typography align="center" variant="h5" color="primary" className={classes.title}>
            {isAddMode ? "Datos del Rol" : "Datos del Usuario"}
          </Typography>
        </Grid>
        <FormProvider {...methods}>
          <Paper className={classes.form}>
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormAutocomplete
                    name="nombreRole"
                    options={nombreRoleOptions}
                    getOptionLabel={(servicio) => `${servicio?.descripcion}`}
                    label="Nombre del Rol"
                    disabled={isReadOnly || isUpdate}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormInput
                    name="username"
                    label="Usuario"
                    disabled={isReadOnly || isUpdate}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormInput
                    name="cedulaIdentidad"
                    label="Cédula de Identidad"
                    disabled={isReadOnly}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormInput
                    name="nombres"
                    label="Nombres"
                    disabled={isReadOnly}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormInput
                    name="apellidos"
                    label="Apellidos"
                    disabled={isReadOnly}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormInput
                    name="cargo"
                    label="Cargo"
                    disabled={isReadOnly}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormInput
                    name="telefono"
                    label="Teléfono"
                    disabled={isReadOnly}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormInput
                    name="email"
                    label="E-mail"
                    disabled={isReadOnly}
                  />
                </Grid>
              </Grid>
            </form>
          </Paper>
        </FormProvider>
      </Grid>

      <Grid container justifyContent="flex-end">
        <Button variant="contained" color="default" onClick={() => history.goBack()}>
          Atrás
        </Button>
        {(isAddMode || isUpdate) && (
          <Button variant="contained" color="primary" onClick={handleSubmit(onSubmit)}>
            Guardar
          </Button>
        )}
      </Grid>
    </div>
  );
};

export default Form;
